import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 

class LeaderboardRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getLastLeaderboardByMarket(marketName) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/leaderboards/last/${marketName}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getRankedAccountsByLeaderboard(leaderboardId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/leaderboards/ranked-accounts/${leaderboardId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getInvestmentVotesByUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/leaderboards/ranked-accounts/get-votes`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    voteAsInterestedInvestor(rankedAccountId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/leaderboards/ranked-accounts/vote/${rankedAccountId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new LeaderboardRepository();